import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography, Button } from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/Settings';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    backgroundColor: "#3C3B54",
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
    margin: "-15px -15px 0px -15px",
    padding: 15
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1),
    color: "white",
    fontWeight: 400
  },
  profil: {
    //marginTop: theme.spacing(1),
    color: "#A5A4BF",
    //fontWeight: 400
  },
  settings: {
    //width:"100%"
    //marginTop: theme.spacing(1),
    //color: "#A5A4BF",
    //fontWeight: 400
  },
  icon: {
    color: "#A5A4BF", /*theme.palette.icon*/
    width: 22,
    height: 22,
    //marginRight: theme.spacing(1)
  },
  buttonIcon: {
    display: "flex",
    position: "relative",
    left: 80, 
    padding: 7
  }
}));

const Profile = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const user = {
    name: "Utilisateur",
    avatar: '/images/avatars/avatar_11.png',
    profil: 'Administrateur'
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <IconButton className={classes.buttonIcon}>
        <SettingsIcon className={classes.icon} />
      </IconButton>

      <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={user.avatar}
        to="/settings" 
      />
      <Typography
        className={classes.name}
        variant="h5"
      >
        {user.name}
      </Typography>
      <Typography className={classes.profil} variant="body2">
        {user.profil}
      </Typography>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;
